function ContactBlock({
  eyebrow = "Contact",
  title = "Available for directing and content work.",
  body = "For music videos, brand content, or social media content:",
}) {
  return (
    <section className="section contactSection">
      <div className="contactCard contactCard--full">
        <p className="eyebrow">{eyebrow}</p>
        <h2>{title}</h2>
        <p>{body}</p>
        <div className="contactCard__actions">
          <a className="button button--primary" href="mailto:nathancolesjr@gmail.com">
            Email Me
          </a>
          <a
            className="button button--secondary"
            href="https://instagram.com/nathancolesjr"
            target="_blank"
            rel="noreferrer"
          >
            Instagram
          </a>
        </div>
      </div>
    </section>
  );
}

export default ContactBlock;
